module.exports = __webpack_public_path__ + "static/media/ig-msg.24f03edf.png";